import { defineMessages } from "@/i18n";
import en from "./en";

export const hooksMessages = defineMessages("hooks", en);
